import { useEffect, useState } from "react";
import "./style.scss"
const Singapore = () => {
    useEffect(() => {
        document.title = '港澳中文一對一補習Online - Sino-bus';
    }, [])
    const gtag_report_conversion = (url) => {
        window.open(url, "_blank");
    }
    return <div className="fb-hk-chinese">
        <img className="imgDf" src="../assets/singapore/FB-hk-page.jpg" alt="" onClick={() => { gtag_report_conversion('https://wa.me/8617788052878?text=%E5%92%A8%E8%A9%A2%E4%B8%AD%E6%96%87') }} />
    </div>
}
export default Singapore;